export const noop = () => {}

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const findValueByKey = <T extends Record<string, any>, R = unknown>(obj: T, key: string): R | undefined => {
  const keys = key.split(".")

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  let current: any = obj

  for (const keyPart of keys) {
    if (current === null || current === undefined || typeof current !== "object") {
      return undefined
    }

    if (!(keyPart in current)) {
      return undefined
    }

    /* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */
    current = current[keyPart]
  }

  return current as R
}

/** Helper to remove fields from an object based on a list of allowed keys */
export const filterFieldsByKeys = <T extends Record<string, unknown>>(fields: T, allowedKeys: string[]): Partial<T> => {
  const result = { ...fields }

  Object.keys(result).forEach((key) => {
    const typedKey = key as keyof T
    if (result[typedKey] === undefined || !allowedKeys.includes(key)) {
      delete result[typedKey]
    }
  })

  return result
}

export const isDefined = <T>(argument: T | undefined | null): argument is T =>
  argument !== undefined && argument !== null

export const isDefinedAndNotEmpty = <T>(argument: T | undefined | null): argument is T =>
  isDefined(argument) && (!Array.isArray(argument) || argument.length > 0)
